export default { status:false, content:'', onClick:()=>{}, variant:'success' }